/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-script-url */
/* eslint-disable camelcase */
import React from 'react'
import { Link } from 'react-router-dom'

import { defaultToEmptyString } from '../../assets/ts/formatting/formatting'
import './tabs.css'

interface TabItem {
  content: React.ReactNode
  count?: string
  icon?: string
  id?: number
  isActive: boolean
  tabTitle: string
}

interface Props {
  anchorclass?: any
  badge?: any
  className?: any
  contentstyles?: any
  filter?: any
  id?: any
  info?: any
  infoClassName?: any
  infoIcon?: any
  isButtons?: any
  isInfo?: any
  items?: TabItem[]
  mainTabsclass?: any
  onTabSelected?: (number) => void
  pagetitle?: any
  pagetitleClass?: any
  pagetitleIcon?: any
  setFilter?: (number) => void
  tablistclassName?: any
  tabscontentarea?: any
  tabsul?: any
  type?: any
}
const Tabs = (props: Props) => {
  return (
    <div className={props?.mainTabsclass ? `tabs ${props?.mainTabsclass}` : 'tabs'}>
      <div className={props?.className ? `customtabs ${props?.className}` : 'customtabs'}>
        <ul
          className={props?.tabsul}
          style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
        >
          {props?.pagetitle && (
            <h2 aria-live='polite' className={props?.pagetitleClass} tabIndex={0}>
              {props?.pagetitleIcon && <span className={props?.pagetitleIcon}></span>}
              {defaultToEmptyString(props?.pagetitle)}
            </h2>
          )}
          <div
            className={
              props?.tablistclassName
                ? `customtabs-list ${props?.tablistclassName}`
                : 'customtabs-list'
            }
          >
            {props.items?.map((item: any, index: number) => {
              if (item.isVisible || item.isVisible === undefined) {
                return (
                  <li key={item.tabTitle}>
                    <Link
                      className={
                        item.isActive
                          ? props?.anchorclass
                            ? `active ${props?.anchorclass}`
                            : 'active'
                          : props?.anchorclass
                          ? `${props?.anchorclass}`
                          : ''
                      }
                      key={index}
                      onClick={() => {
                        if (props?.filter)
                          props?.setFilter({
                            ...props.filter,
                            assignedComponentCodeFilter: item?.id,
                          })
                        props.onTabSelected?.(index)
                      }}
                      tabIndex={0}
                      title={defaultToEmptyString(item?.tabTitle)}
                      to='#'
                    >
                      {item?.icon && <span className={item?.icon}></span>}{' '}
                      {defaultToEmptyString(item?.tabTitle)}{' '}
                      {props?.badge && (
                        <span className={props?.badge}>{defaultToEmptyString(item?.count)}</span>
                      )}
                      {props?.isInfo && (
                        <span
                          className={props?.infoClassName}
                          data-tip={props?.info || item?.tabTitle}
                        >
                          <span className={props?.infoIcon}></span>
                        </span>
                      )}
                    </Link>
                  </li>
                )
              }
            })}
          </div>
          {props?.isButtons}
        </ul>
        <div className='d-flex flex-wrap flex-column flex-sm-row justify-content-sm-end gap-1 ms-sm-auto'></div>
      </div>
      <div className={props?.tabscontentarea}>
        {props.items?.map(({ content, isActive, tabTitle }) => {
          return (
            <div key={tabTitle}>
              {isActive && (
                <div className={`customtabs-content ${isActive ? 'active' : ''}`}>
                  <div className={props?.contentstyles}>{content}</div>
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
export default Tabs
export { type TabItem }
